/* Bara de anunt: mesaje Black Friday 2026. Suprascrie scriptul "MEGA DEALS" din layout/theme.liquid (ciclu de 3 zile cu countdown fals) printr-un MutationObserver. Fara countdown de final. */
(function(){
  var START=Date.parse("2026-11-06T00:00:00+02:00"),LINK="/pages/black-friday",live=Date.now()>=START;
  var MSGS=[
    live?"⚡ BLACK FRIDAY — ofertele sunt live":"⚡ BLACK FRIDAY — 6 noiembrie, ora 00:00",
    "🚀 Livrare 24h — Easybox sau Curier",
    "🛡️ Garanție 24 luni • Retur gratuit 14 zile",
    "🔥 Reduceri până la 70%, reale"
  ];
  function apply(){
    var items=document.querySelectorAll(".announcement-bar--item");
    for(var i=0;i<items.length;i++){
      var m=MSGS[i%MSGS.length],a=items[i].querySelector("a");
      if(a){if(a.innerHTML!==m)a.innerHTML=m;a.setAttribute("href",LINK);a.removeAttribute("target");}
      else if(items[i].innerHTML!==m){items[i].innerHTML=m;}
    }
  }
  function start(){
    var bar=document.querySelector(".announcement-bar");
    if(!bar){setTimeout(start,300);return;}
    apply();
    new MutationObserver(function(){apply();}).observe(bar,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start);else start();
})();
